import * as utilDT from '../tagueo/UtilDatalayer';

const VERSION_DATALAYER = '20230622_4.1.1';

export const TAG_PANT_INICIO = 'inicio';
export const TAG_PANT_INICIO_EVENTO_CLICK = 'inicio-click';
export const TAG_PANT_CUENTAS = 'cuentas';
export const TAG_PANT_PERFILADOR_CUENTAS = 'perfilador-cuentas';
export const TAG_PANT_IDENTIDAD = 'identidad';
export const TAG_PANT_SEGURIDAD = 'seguridad';
export const TAG_PANT_DATOS_OCUPACION = 'datos_ocupacion';
export const TAG_PANT_TERMINOS = 'terminos';
export const TAG_PANT_TERMINOS_DIGITAL = 'terminos-digital';
export const TAG_PANT_FINAL = 'final';
export const TAG_PANT_FINAL_NINGUNA = 'final_ninguna';
export const TAG_PANT_FINAL_TARJETA = 'final_tarjeta';
export const TAG_PANT_FINAL_PRESTAMO = 'final_prestamo';
export const TAG_PANT_FINAL_LISTA_NEGRA = 'error-inelegibles';
export const TAG_PANT_FINAL_NO_PERUANO = 'No_Peruano';
export const TAG_PANT_FINAL_USUARIO_PEP = 'error-pep';
export const TAG_PANT_ERROR_MENOR_EDAD = 'error-menor-edad';
export const TAG_PANT_CLAVE_SMS = 'clave sms';
export const TAG_PANT_CLAVE_SMS_DIGITAL = 'clave sms-digital';

export const TAG_PANT_ERROR_CANDADO = 'error-preguntas-candado';
export const TAG_PANT_ERROR_CANDADO_REINGRESO = 'error-blk-candado';
export const TAG_PANT_ERROR_SERVICIOS = 'Error_Servicios';
export const TAG_PANT_ERROR_LIMITES = 'error-limite';
export const TAG_PANT_ERROR_RENIEC = 'error-reniec';
export const TAG_PANT_ERROR_CAIDA_RENIEC = 'error-caida-reniec';
export const TAG_PANT_ERROR_CONTRATACION = 'Error_Contratacion';
export const TAG_PANT_ERROR_CONTRATACION_DIGITAL = 'Error_Contratacion_Digital';
export const TAG_PANT_ERROR_DIRECCION = 'Error_Direccion';
export const TAG_PANT_ERROR_DIRECCION_EXTRANJERA = 'error-direccion-extranjera';
export const TAG_PANT_ERROR_DIRECCION_NACIONAL_SIN_UBIGEO =
  'error-direccion-nacional-sin-ubigeo';
export const TAG_PANT_ERROR_DIRECCION_INCOMPLETA = 'error-direccion-incompleta';
export const TAG_PANT_ERROR_COLABORADOR = 'error-colaborador';
export const TAG_PANT_ERROR_RENIEC_NO_EXISTE = 'error-noexiste-reniec';
export const TAG_PANT_ERROR_LIST_CONTRACTS = 'error-contracts';
export const TAG_PANT_ERROR_LIST_CUSTOMER = 'error-customer';
export const TAG_PANT_ERROR_GT = 'error-gt';
export const TAG_PANT_ERROR_GT_3 = 'error-gt-3';
export const TAG_PANT_ERROR_GT_4 = 'error-gt-4';
export const TAG_PANT_ERROR_GT_6 = 'error-gt-6';
export const TAG_PANT_ERROR_GIFOLE_2 = 'error-gifole-2';
export const TAG_PANT_ERROR_GIFOLE_6 = 'error-gifole-6';
export const TAG_PANT_ERROR_CATALOG = 'error-catalog';
export const TAG_PANT_ERROR_CREATE_CUSTOMER = 'error-create-customer';
export const TAG_PANT_ERROR_SMS_BASE = 'error-sms-base';
export const TAG_PANT_ERROR_FECHA_NAC = 'error-fecha-nac';

export const TAG_CLAVE_SMS = 'clave_sms';
export const TAG_VOLVER_SOLICITAR_CODIGO = 'volver_solicitar_codigo';
export const TAG_CONTINUAR = 'boton_continuar';
export const TAG_CROSS_SELL_LO_QUIERO_TARJETA = 'boton_lo_quiero_tarjeta';
export const TAG_CROSS_SELL_LO_QUIERO_PRESTAMO = 'boton_lo_quiero_prestamo';

export const BTN_EMPEZAR = 'empieza ahora';
export const CONTINUAR = 'continuar';
export const ABRIR_CUENTA = 'abrir cuenta';

const CTA_FACIL = 'CNTFCL';
const CTA_SUELDO = 'CNTSLD';
const CTA_INDEPENDENCIA = 'CNTIND';
const CTA_GANADORA = 'CNTGNDR';
const CTA_WELLNESS = 'CNTVIP';
const CTA_CTE = 'CNTCRRNT';
const CTA_DIGITAL = 'CNTCDBBVA';
const ENTORNO_PROD = 'bbvaperuprod';
const TAGUEO_INSTANCE_ID_PROD = 'pro';
const TAGUEO_INSTANCE_ID_PREV = 'de';
const TAGUEO_OPEN_MARKET = 'open market';
const TAGUEO_CROSSELL = 'crossell';

var monedaCuenta;
var codigoCuenta;
var nombreCuenta = '';
var estadoCliente;
var entornoTagueo;

var earnings = '';
var jobType = '';
var customFields = '';
let numCelular='';
let correo='';

export function setOperationNumber(sDigitalData) {
  utilDT.setOperationNumber(sDigitalData);
}

export function llenarDataLayer(page, elemento) {
  limpiezaCamposDT();
  setDataLayerBasica();
  if (TAG_PANT_INICIO === page) {
    setDataLayerAppPageVisit();
  } else if (TAG_PANT_INICIO_EVENTO_CLICK === page) {
    setDataLayerOnClick(elemento);
  } else if (TAG_PANT_CUENTAS === page) {
    setDataLayerAppStep2();
  } else if (TAG_PANT_PERFILADOR_CUENTAS === page) {
    setDataLayerPerfilador();
  } else if (TAG_PANT_IDENTIDAD === page) {
    setDataLayerAppStep3();
  } else if (TAG_PANT_TERMINOS === page) {
    setDataLayerAppStep4();
  } else if (TAG_PANT_TERMINOS_DIGITAL === page) {
    setDataLayerAppStep3Digital();
  } else if (TAG_PANT_CLAVE_SMS === page) {
    setDataLayerAppStep5();
  } else if (TAG_PANT_CLAVE_SMS_DIGITAL === page) {
    setDataLayerAppStep4Digital();
  } else if (TAG_PANT_FINAL === page) {
    setDataLayerAppCompleted();
  } else if (TAG_PANT_FINAL_TARJETA === page) {
    setDataLayerAppCompletedTarjeta();
  } else if (TAG_PANT_FINAL_PRESTAMO === page) {
    setDataLayerAppCompletedPrestamo();
  } else if (TAG_PANT_FINAL_NINGUNA === page) {
    setDataLayerAppCompletedNinguna();
  } else if (TAG_PANT_FINAL_LISTA_NEGRA === page) {
    setDataLayerAppCompletedListaNegra();
  } else if (TAG_PANT_FINAL_NO_PERUANO === page) {
    setDataLayerAppCompletednNoPeruano();
  } else if (TAG_PANT_FINAL_USUARIO_PEP === page) {
    setDataLayerAppCompletedUsuarioPep();
  } else if (TAG_PANT_ERROR_MENOR_EDAD === page) {
    setDataLayerAppCompletedErrorMenorEdad();
  } else if (TAG_PANT_ERROR_SERVICIOS === page) {
    setDataLayerErrorServicios();
  } else if (TAG_PANT_ERROR_LIMITES === page) {
    setDataLayerErrorLimites();
  } else if (TAG_PANT_ERROR_RENIEC === page) {
    setDataLayerErrorReniec();
  } else if (TAG_PANT_ERROR_CAIDA_RENIEC === page) {
    setDataLayerErrorCaidaReniec();
  } else if (TAG_PANT_ERROR_CONTRATACION === page) {
    setDataLayerErrorContratacion();
  } else if (TAG_PANT_ERROR_CONTRATACION_DIGITAL === page) {
    setDataLayerErrorContratacionDigital();
  } else if (TAG_PANT_ERROR_DIRECCION === page) {
    setDataLayerErrorDireccion();
  } else if (TAG_PANT_ERROR_DIRECCION_EXTRANJERA === page) {
    setDataLayerErrorDireccionExtranjera();
  } else if (TAG_PANT_ERROR_DIRECCION_NACIONAL_SIN_UBIGEO === page) {
    setDataLayerErrorDireccionNacionalSinUbigeo();
  } else if (TAG_PANT_ERROR_DIRECCION_INCOMPLETA === page) {
    setDataLayerErrorDireccionIncompleta();
  } else if (TAG_CLAVE_SMS === page) {
    setDataLayerInteractionLinkClaveSMS();
  } else if (TAG_VOLVER_SOLICITAR_CODIGO === page) {
    setDataLayerInteractionLinkVolveraSolicitarCodigo();
  } else if (TAG_PANT_ERROR_COLABORADOR === page) {
    setDataLayerErrorColaborador();
  } else if (TAG_PANT_ERROR_RENIEC_NO_EXISTE === page) {
    setDataLayerErrorReniecNoExiste();
  } else if (TAG_PANT_ERROR_LIST_CONTRACTS === page) {
    setDataLayerErrorListContracts();
  } else if (TAG_PANT_ERROR_LIST_CUSTOMER === page) {
    setDataLayerErrorListCustomer();
  } else if (TAG_PANT_ERROR_GT === page) {
    setDataLayerErrorGrantingTicket('1');
  } else if (TAG_PANT_ERROR_GT_3 === page) {
    setDataLayerErrorGrantingTicket('3');
  } else if (TAG_PANT_ERROR_GT_4 === page) {
    setDataLayerErrorGrantingTicket('4');
  } else if (TAG_PANT_ERROR_GT_6 === page) {
    setDataLayerErrorGrantingTicket('6');
  } else if (TAG_PANT_ERROR_GIFOLE_2 === page) {
    setDataLayerErrorGifole('2');
  } else if (TAG_PANT_ERROR_GIFOLE_6 === page) {
    setDataLayerErrorGifole('6');
  } else if (TAG_PANT_ERROR_CATALOG === page) {
    setDataLayerErrorListCatalog();
  } else if (TAG_PANT_ERROR_CREATE_CUSTOMER === page) {
    setDataLayerErrorCreateCustomer();
  } else if (TAG_PANT_ERROR_SMS_BASE === page) {
    setDataLayerErrorSmsBase();
  } else if (TAG_CONTINUAR === page) {
    setDataLayerInternalLinkContinuar(elemento);
  } else if (TAG_PANT_ERROR_FECHA_NAC === page) {
    setDataLayerErrorBlkFechaNacimiento();
  } else if (TAG_CROSS_SELL_LO_QUIERO_TARJETA === page) {
    setDataLayerAppOnClickStartTarjeta(elemento);
  } else if (TAG_CROSS_SELL_LO_QUIERO_PRESTAMO === page) {
    setDataLayerAppOnClickStartPrestamo();
  }
}

function setDataLayerBasica() {
  //Setear campos genericos
  utilDT.setVersionDL(VERSION_DATALAYER);
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setPageIntent('transaccion');
  utilDT.setPageSegment('personas');
  utilDT.setSysEnv();
  utilDT.setVersion('1.0');
  utilDT.setChannel('online');
  utilDT.setLanguage('ES');
  utilDT.setGeoRegion('');
  utilDT.setArea('publica');
  utilDT.setServer();
  utilDT.setBusinessUnit('BBVA Peru');
  utilDT.setSiteAppName('BBVA Peru');
  utilDT.setUserState('no logado');
  utilDT.setUserAgent();
  utilDT.setMobile();
  utilDT.setPrimaryCategory('cuentas');
  utilDT.setGlobalApplication('onboarding account');
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');

  //datos globales
  utilDT.setLevel(1, 'cuentas');
  utilDT.setLevel(2, 'apertura de cuentas');
}

function limpiezaCamposDT() {
  //Limpiar campos no genericos
  utilDT.setApplicationState('');
  utilDT.setSegmentProfile('');
  utilDT.setErrorPage('');
  utilDT.setApplicationStep('');
}

function setDataLayerAppPageVisit() {
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '1 introduce tus datos');
  utilDT.setPageName();
  utilDT.setApplicationStep('1 introduce tus datos');
  utilDT.setApplicationState('inicio');
  utilDT.setIsQualifiedVisits('true');

  lanzarEventDigital_View('App Page Visit');
}

function setDataLayerOnClick(elemento) {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, '1 introduce tus datos');
  utilDT.setPageName();
  utilDT.setApplicationStep(elemento);

  lanzarEventDigital_Link('App Started');
}

function setDataLayerAppStep2() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '2 eleccion de cuenta');
  utilDT.setPageName();

  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);

  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('2 eleccion de cuenta');
  utilDT.setPhone(numCelular);
  utilDT.setEmail(correo);

  lanzarEventDigital_View('App Step 2');
}

function setDataLayerPerfilador() {
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '2 eleccion de cuenta');
  utilDT.setPageName();

  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('perfilador');

  lanzarEventDigital_View('huellaAvanzadaPartePublica');
}

function setDataLayerAppStep3() {
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '3 identidad y ubicacion');
  utilDT.setPageName();
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setCurrency(monedaCuenta);
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('3 identidad y ubicacion');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setPhone(numCelular);
  utilDT.setEmail(correo);

  lanzarEventDigital_View('App Step 3');
}


function setDataLayerAppStep4() {
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '4 terminos y condiciones');
  utilDT.setPageName();
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setCurrency(monedaCuenta);
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('4 terminos y condiciones');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setPhone(numCelular);
  utilDT.setEmail(correo);

  lanzarEventDigital_View('App Step 4');
}

function setDataLayerAppStep3Digital() {
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '3 terminos y condiciones');
  utilDT.setPageName();
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setCurrency(monedaCuenta);
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('3 terminos y condiciones');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setPhone(numCelular);
  utilDT.setEmail(correo);

  lanzarEventDigital_View('App Step 3');
}

function setDataLayerAppStep5() {
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '5 clave sms');
  utilDT.setPageName();
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setCurrency(monedaCuenta);
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('5 clave sms');
  utilDT.setCustomFields(obtenerCustomFields());

  lanzarEventDigital_View('App Step 5');
}

function setDataLayerAppStep4Digital() {
  utilDT.setPageInstanceID(obtenerEntorno());
  utilDT.setLevel(3, '4 clave sms');
  utilDT.setPageName();
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setCurrency(monedaCuenta);
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('4 clave sms');
  utilDT.setCustomFields(obtenerCustomFields());

  lanzarEventDigital_View('App Step 4');
}

function setDataLayerAppCompleted() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setProductState('contratado');
  utilDT.setApplicationType('contratacion');
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setCurrency(monedaCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('contratado');
  utilDT.setCustomFields(obtenerCustomFields());

  lanzarEventDigital_View('App Completed');
}

function setDataLayerAppCompletedTarjeta() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setProductState('contratado');
  utilDT.setApplicationType('contratacion');
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setCurrency(monedaCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('contratado');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setOffer("con banner tc crossell");

  lanzarEventDigital_View('App Completed');
}

function setDataLayerAppCompletedPrestamo() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setProductState('contratado');
  utilDT.setApplicationType('contratacion');
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setCurrency(monedaCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('contratado');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setOffer("con banner pld crossell");

  lanzarEventDigital_View('App Completed');
}

function setDataLayerAppCompletedNinguna() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setProductState('contratado');
  utilDT.setApplicationType('contratacion');
  utilDT.setProductSubtype(obtenerProductSubType());
  utilDT.setProductName(nombreCuenta);
  utilDT.setCurrency(monedaCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('contratado');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setOffer("sin banner crossell");

  lanzarEventDigital_View('App Completed');
}

function setDataLayerAppCompletedListaNegra() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('inelegible');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerAppCompletednNoPeruano() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('bloqueado por preg facta');
  utilDT.setTypology(obtenerEstadoCliente());
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setCurrency(monedaCuenta);
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerAppCompletedUsuarioPep() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('pep');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerAppCompletedErrorMenorEdad() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, '1 introduce tus datos');
  utilDT.setPageName();
  utilDT.setApplicationErrorType('error menor de edad');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Site Error');
}

function setDataLayerErrorServicios() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'servicios no responden');
  utilDT.setPageName();
  utilDT.setErrorPage('servicios no responden');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorLimites() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('bloqueado por nro mx cuentas');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerErrorReniec() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'error reniec');
  utilDT.setPageName();
  utilDT.setErrorPage('error reniec');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorCaidaReniec() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'error caida reniec');
  utilDT.setPageName();
  utilDT.setErrorPage('error caida reniec');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorContratacion() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, '4 terminos y condiciones');
  utilDT.setPageName();
  utilDT.setApplicationErrorType('error sms usuario');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Site Error');
}

function setDataLayerErrorContratacionDigital() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, '3 terminos y condiciones');
  utilDT.setPageName();
  utilDT.setApplicationErrorType('error sms usuario');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Site Error');
}

function setDataLayerErrorDireccion() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, '3 identidad y ubicacion');
  utilDT.setPageName();

  utilDT.setApplicationErrorType('error direccion usuario');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Site Error');
}

function setDataLayerErrorDireccionExtranjera() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('bloqueado por dir extranjera');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerErrorDireccionNacionalSinUbigeo() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('bloqueado por dir nacional sin ubigeo');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerErrorDireccionIncompleta() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('bloqueado por dir incompleta');
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerInteractionLinkClaveSMS() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setInteractionLevel('campo sms');
  utilDT.setGlobalApplication('');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setEarnings('');
  utilDT.setJobType('');
  utilDT.setCurrency('');
  utilDT.setFulfillmentModel('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Interaction Link');
}

function setDataLayerInteractionLinkVolveraSolicitarCodigo() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setInteractionLevel('volver a solicitar codigo');
  utilDT.setGlobalApplication('');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setEarnings('');
  utilDT.setJobType('');
  utilDT.setCurrency('');
  utilDT.setFulfillmentModel('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Interaction Link');
}

function setDataLayerErrorColaborador() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationName('apertura de cuentas');
  utilDT.setFulfillmentModel('online');
  utilDT.setApplicationStep('pagina exitosa');
  utilDT.setApplicationState('rechazado');
  utilDT.setSegmentProfile('colaborador del banco');
  utilDT.setCustomFields(obtenerCustomFields());
  utilDT.setEarnings(earnings);
  utilDT.setJobType(removeAccents(toLowerCase(jobType)));
  utilDT.setProductState('rechazado');

  lanzarEventDigital_View('App Completed');
}

function setDataLayerErrorReniecNoExiste() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, '1 introduce tus datos');
  utilDT.setPageName();
  utilDT.setApplicationErrorType('error usuario reniec');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Site Error');
}

function setDataLayerErrorBlkFechaNacimiento() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, '1 introduce tus datos');
  utilDT.setPageName();
  utilDT.setApplicationErrorType('error fecha nacimiento');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Site Error');
}

function setDataLayerErrorListContracts() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'list contracts information error');
  utilDT.setPageName();
  utilDT.setErrorPage('list contracts information error');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorListCustomer() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'list customer error');
  utilDT.setPageName();
  utilDT.setErrorPage('list customer error');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorGrantingTicket(paso) {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'create ticket error ' + paso);
  utilDT.setPageName();
  utilDT.setErrorPage('create ticket error ' + paso);
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorGifole(paso) {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'error gifole ' + paso);
  utilDT.setPageName();
  utilDT.setErrorPage('error gifole ' + paso);
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorListCatalog() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'list catalogs error');
  utilDT.setPageName();
  utilDT.setErrorPage('list catalogs error');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorCreateCustomer() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'create customer error');
  utilDT.setPageName();
  utilDT.setErrorPage('create customer error');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

function setDataLayerErrorSmsBase() {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLevel(3, 'error sms base');
  utilDT.setPageName();
  utilDT.setErrorPage('error sms base');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setFulfillmentModel('');
  utilDT.setGlobalApplication('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_View('Page View');
}

export function setCodigoCuenta(codCuenta) {
  codigoCuenta = codCuenta;
}

export function setNombreCuenta(nomCuenta) {
  nombreCuenta = nomCuenta.toLowerCase();
}

function obtenerProductSubType() {
  var cta = codigoCuenta;
  var productName = '';

  if (cta === CTA_FACIL) {
    productName = 'cuentas ahorro';
  } else if (cta === CTA_SUELDO) {
    productName = 'cuentas ahorro';
  } else if (cta === CTA_INDEPENDENCIA) {
    productName = 'cuentas ahorro';
  } else if (cta === CTA_GANADORA) {
    productName = 'cuentas ahorro';
  } else if (cta === CTA_DIGITAL) {
    productName = 'cuentas ahorro';
  }else if (cta === CTA_WELLNESS) {
    productName = 'cuentas corrientes';
  } else if (cta === CTA_CTE) {
    productName = 'cuentas corrientes';
  }

  return productName;
}

export function setCodigoMoneda(codMoneda) {
  monedaCuenta = codMoneda;
}

export function setEntornoTagueo(entornoTag) {
  entornoTagueo = entornoTag;
}

function obtenerEntorno() {
  return ENTORNO_PROD === entornoTagueo
    ? TAGUEO_INSTANCE_ID_PROD
    : TAGUEO_INSTANCE_ID_PREV;
}

export function setEstadoCliente(estCliente) {
  estadoCliente = estCliente;
}

function obtenerEstadoCliente() {
  return true === estadoCliente ? TAGUEO_OPEN_MARKET : TAGUEO_CROSSELL;
}

export function setEarningsCustomer(earningsCustomer) {
  earnings = earningsCustomer;
}

export function setJobTypeCustomer(jobTypeCustomer) {
  jobType = jobTypeCustomer;
}

export function setCustomFields(mostrarDireccion) {
  customFields = mostrarDireccion === undefined ? '' : mostrarDireccion ? 'direccion incompleta' : 'direccion completa';
}

export function obtenerCustomFields() {
  return obtenerEstadoCliente() === TAGUEO_CROSSELL ? 'direccion completa' : customFields;
}

export function setNumCelular(nCelular) {
  numCelular = nCelular;
}

export function setCorreo(nCorreo) {
  correo = nCorreo;
}

function setDataLayerInternalLinkContinuar(elemento) {
  utilDT.setIsQualifiedVisits('');
  utilDT.setLinkName(elemento);
  utilDT.setGlobalApplication('');
  utilDT.setApplicationType('');
  utilDT.setApplicationName('');
  utilDT.setEarnings('');
  utilDT.setJobType('');
  utilDT.setCurrency('');
  utilDT.setFulfillmentModel('');
  utilDT.setTypology('');
  utilDT.setProductsAtributes('');

  lanzarEventDigital_Link('Internal Link');
}

function setDataLayerAppOnClickStartTarjeta(elemento) {
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setCustomFields('');
  utilDT.setTypology('');
  utilDT.setGlobalApplication('onboarding credit card');
  utilDT.setApplicationName('formulario tarjeta credito');
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationStep('lo quiero pagina exitosa cuentas');
  utilDT.setFulfillmentModel('online/offline');
  utilDT.setPrimaryCategory('tarjetas');
  utilDT.setProductSubtype('tarjetas credito');
  utilDT.setProductName(elemento);
  utilDT.setProductState('');
  utilDT.setOffer('');
  lanzarEventDigital_Link('App On Click Start');
}

function setDataLayerAppOnClickStartPrestamo() {
  utilDT.setLevel(3, 'pagina exitosa');
  utilDT.setPageName();
  utilDT.setCustomFields('');
  utilDT.setTypology('');
  utilDT.setGlobalApplication('onboarding loan');
  utilDT.setApplicationName('formulario prestamo personal');
  utilDT.setApplicationType('contratacion');
  utilDT.setApplicationStep('lo quiero pagina exitosa cuentas');
  utilDT.setFulfillmentModel('online/offline');
  utilDT.setPrimaryCategory('prestamos');
  utilDT.setProductSubtype('prestamos personales');
  utilDT.setProductName('prestamo de libre disponibilidad');
  utilDT.setProductState('');
  utilDT.setOffer('');
  lanzarEventDigital_Link('App On Click Start');
}

function lanzarEventDigital_View(evento) {
  lanzarEvento('digitalView', evento);
}

function lanzarEventDigital_Link(evento) {
  lanzarEvento('digitalLink', evento);
}

function lanzarEvento(tipoEvent, evento) {
  window.digitalData = utilDT.getDigitalData();
  try {
    if (tipoEvent === 'digitalView')
      window.digitalView(evento, utilDT.getDigitalData());
    else if (tipoEvent === 'digitalLink')
      window.digitalLink(evento, utilDT.getDigitalData());
  } catch (err) {
    console.info('error tag');
  }
}

const toLowerCase=(str)=> {
	if(str !== undefined) return str.toLowerCase();
	return '';
}

const removeAccents=(str)=> {
  if(str !== undefined) return str.normalize("NFD").replace(/[/\-.\u0300-\u036f]/g, ''); 
	return '';
} 
